import React from 'react';
import PropTypes from 'prop-types';

import { withViewportWidth } from 'decorators';
import { H3, Paragraph } from 'components/core/Typography';
import { Arrow } from 'components/svg';

import './AveragePricesContent.scss';

export const enhance = withViewportWidth;

export function AveragePricesHeader({
	avgPrice,
	city,
	historyLength,
	priceDifference,
	totalReservations,
}) {
	return (
		<div className="average-prices-header">
			<div className="avg-description">
				<H3
					size="medium"
					weight="extraBold"
					color="darkGray"
					last
				>
					Average Unit Price
				</H3>
				<Paragraph
					size="small"
					weight="standard"
					color="darkGray"
					last
				>
					{`Based on ${totalReservations} storage units reserved in ${city} over the past ${historyLength} months.`}
				</Paragraph>
			</div>
			<div className="avg-stats">
				<Paragraph
					size="megaMobile"
					color="darkGray"
					last
				>
					{`$${avgPrice.toFixed(2)}`}
				</Paragraph>
				<div className="yesterday-comparison">
					<Paragraph
						className="price-difference"
						size="small"
						weight="extraBold"
						color="darkGray"
						last
					>
						<Arrow
							direction={priceDifference > 0 ? 'down' : 'up'}
						/>
						{`${priceDifference > 0 ? 'Down' : 'Up'} $${Math.abs(priceDifference).toFixed(2)}`}
					</Paragraph>
					<Paragraph
						size="smallMedium"
						weight="standard"
						color="placeholderGray"
						last
					>
						Compared to last month
					</Paragraph>
				</div>
			</div>
		</div>
	);
}

AveragePricesHeader.propTypes = {
	avgPrice: PropTypes.string.isRequired,
	city: PropTypes.string.isRequired,
	historyLength: PropTypes.number.isRequired,
	priceDifference: PropTypes.number.isRequired,
	totalReservations: PropTypes.number.isRequired,
};

export default AveragePricesHeader;
